import { Box, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import getConfig from 'next/config';
import getGeneralImage from '../../../util/getGeneralImage';
import styles from './styles';

const { publicRuntimeConfig } = getConfig();
const BroadbandPrequalAdvertisement = props => {
  const theme = useTheme();
  const sm = useMediaQuery(theme.breakpoints.down('sm'));
  const smallLaptop = useMediaQuery(theme.breakpoints.between(900, 1350));

  const getUrl = () => {
    let url;
    if (sm) {
      url = `${publicRuntimeConfig.NEXT_PUBLIC_STRAPI}${
        getGeneralImage({
          generalImageArray: props.imageData?.attributes?.Prequal?.offerImg,
          key: 'offerImage',
          view: 'MobileViewImage',
        }).url
      }`;
    } else if (smallLaptop) {
      url = `${publicRuntimeConfig.NEXT_PUBLIC_STRAPI}${
        getGeneralImage({
          generalImageArray: props.imageData?.attributes?.Prequal?.offerImg,
          key: 'offerImage',
          view: 'TabletViewImage',
        }).url
      }`;
    } else {
      url = `${publicRuntimeConfig.NEXT_PUBLIC_STRAPI}${
        getGeneralImage({
          generalImageArray: props.imageData?.attributes?.Prequal?.offerImg,
          key: 'offerImage',
          view: 'DesktopViewImage',
        }).url
      }`;
    }
    return url;
  };
  const getAltText = () => {
    let altText;
    if (sm) {
      altText = getGeneralImage({
        generalImageArray: props.imageData?.attributes?.Prequal?.offerImg,
        key: 'offerImage',
        view: 'MobileViewImage',
      }).alt;
    } else if (smallLaptop) {
      altText = getGeneralImage({
        generalImageArray: props.imageData?.attributes?.Prequal?.offerImg,
        key: 'offerImage',
        view: 'TabletViewImage',
      }).alt;
    } else {
      altText = getGeneralImage({
        generalImageArray: props.imageData?.attributes?.Prequal?.offerImg,
        key: 'offerImage',
        view: 'DesktopViewImage',
      }).alt;
    }
    return altText;
  };
  return (
    // <Box
    //   sx={{
    //     ...styles(theme).advertImage,
    //     background: `url(${getUrl()}) center top/100% 100% no-repeat`,
    //   }}
    // />
    <Box sx={styles(theme).advertImage}>
      <img src={getUrl()} alt={getAltText()} style={{ width: '100%', height: '100%' }} />
    </Box>
  );
};

export default BroadbandPrequalAdvertisement;
